import axios from "axios";
import Swal from "sweetalert2";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const axiosInstance = axios.create({
  baseURL: "https://apiemiride.socialpartners.in/api",
  headers: { "Content-Type": "application/json" },
});

// ✅ Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const companyId = localStorage.getItem("company_id");

    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (companyId) config.headers["x-company-id"] = companyId;

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token) => {
              originalRequest.headers.Authorization = "Bearer " + token;
              resolve(axiosInstance(originalRequest));
            },
            reject: (err) => reject(err),
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token found");

        const res = await axios.post("https://apiemiride.socialpartners.in/api/auth/refresh-token", {
          refreshToken,
        });

        const newAccessToken = res.data.accessToken;
        localStorage.setItem("token", newAccessToken);

        processQueue(null, newAccessToken);

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    if (error.response?.status === 403) {
      if (error.response.data?.message === "No active subscription. Please pay to continue.") {
        const result = await Swal.fire({
          icon: "warning",
          title: "Subscription Expired",
          text: "Your subscription has expired. Please renew to continue.",
          showCancelButton: true,
          confirmButtonText: "Renew",
          cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
          window.location.href = "/plans";
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Subscription Expired",
          text: error.response.data.message || "Please renew your plan to continue.",
        });
      }

      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
